import { BillRecurringEventType } from './types';

const billRecurringEventTypeTextMap: Record<BillRecurringEventType, string> = {
  ONE_TIME: 'One time',
  MONTHLY: 'Monthly',
  WEEKLY: 'Weekly',
};

export const getBillRecurringEventTypeText = (eventType: BillRecurringEventType): string => billRecurringEventTypeTextMap[eventType] || 'Unknown';

export const isOneTimeBill = (eventType: BillRecurringEventType): boolean => eventType === BillRecurringEventType.ONE_TIME;
export const isWeeklyBill = (eventType: BillRecurringEventType): boolean => eventType === BillRecurringEventType.WEEKLY;
export const isMonthlyBill = (eventType: BillRecurringEventType): boolean => eventType === BillRecurringEventType.MONTHLY;

export const getMaxNumOfPaymentsOptions = (eventType: BillRecurringEventType): number => {
  switch (eventType) {
    case BillRecurringEventType.ONE_TIME:
      return 1;
    case BillRecurringEventType.MONTHLY:
      return 24;
    case BillRecurringEventType.WEEKLY:
      return 60;
    default:
      return 1;
  }
};

export const MIN_DAYS_FOR_REMINDER = 3;
